import React from 'react'
import { PhoneNumberLink } from '../../../components/PhoneNumberLink'
import { EmailLink } from '../../../components/EmailLink'
import { SeeYourOrderButton } from '../SeeYourOrderButton'
import { useParams } from 'react-router-dom'
import { Alert, Icon } from '@ztechapps/webui.util'
import { PageTitle } from '../../../components/PageTitle'

export const Page = () => {
  const { _id } = useParams()
  return (
    <div className="container">
      <PageTitle
        title="Order Cancelled"
        description="Your order was not completed. Please contact us if you need assistance."
      />
      <div className="my-5 text-center">
        <Alert type="warning">
          <div style={{ fontSize: '100px' }}>
            <Icon name="ban" />
          </div>

          <h1>
            Payment was cancelled!
            <br />
          </h1>
          <p>
            Please let us know what was wrong, by calling us at{' '}
            <span>
              <PhoneNumberLink />
            </span>{' '}
            or email at{' '}
            <span>
              <EmailLink />
            </span>
          </p>
          <SeeYourOrderButton _id={_id} />
        </Alert>
      </div>
    </div>
  )
}

export default Page
